import {
  Component, EventEmitter, Input, Output,
} from '@angular/core';
import { DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import * as moment from 'moment';
import { P } from '../../ui-kit';
import { TableData, TableEvent } from '../table/table.component';

@Component({
  selector: 'lib-calls',
  templateUrl: './calls.component.html',
  styleUrls: ['./calls.component.scss'],
})
export class CallsComponent {
  @Input() userId: string = '';

  @Input() set calls(calls: P.Call[]) {
    this.setData(calls);
  }

  @Input() working: boolean = false;

  @Output() onCallUpdate: EventEmitter<{id: string, data: Partial<P.Call>}> = new EventEmitter();

  @Output() onOutboundCallClick: EventEmitter<any> = new EventEmitter();

  data: TableData | undefined;

  constructor(
    private router: Router,
    private datePipe: DatePipe,
  ) {}

  onTableEvent(event: TableEvent): void {
    switch (event.type) {
      case 'tel':
        window.open(`tel:${event.data}`);
        break;
      case 'cancel':
        if (typeof event.data === 'string') {
          window.open(
            `https://calendly.com/cancellations/${event.data}`,
            '_blank',
          );
        } else {
          window.open(event.data.cancel_url, '_blank');
        }
        break;
      case 'profile':
        this.router.navigate([`/broker/leads/${event.data}`]);
        break;
      case 'own':
        this.updateCall(event.data, { assignedTo: this.userId });
        break;
      case 'no-answer':
        this.updateCall(event.data.id, { noAnswer: true });
        break;
      case 'answered':
        this.updateCall(event.data, { taken_by: this.userId, noAnswer: false });
        break;
      default:
        break;
    }
  }

  updateCall(callId: string, callData: Partial<P.Call>) {
    this.onCallUpdate.emit({ id: callId, data: callData });
  }

  handleOutboundCallButtonClick() {
    this.onOutboundCallClick.emit();
  }

  get callsCount(): number {
    return this.data?.rows?.length ?? 0;
  }

  private setData(calls: P.Call[]) {
    this.data = <TableData>{
      headers: [
        { label: 'Date', sortable: true, flex: 's' },
        { label: 'Type', sortable: true, flex: 'l' },
        { label: 'Customer', flex: 'l' },
        { label: 'Owner', sortable: true },
      ],
      rows: (calls || []).reverse().map((call: any) => {
        const callStartTime = call.event?.invitee_start_time || call.createdAt;

        return {
          columns: [
            {
              value: moment(callStartTime).format('ll'),
              data: new Date(callStartTime),
              legend: { value: moment(callStartTime).format('hh:mm a') },
            },
            {
              value: call.callType === 'Outbound' ? 'Outbound' : call.source_data?.event_type?.name,
              data: call.source_data?.event_type?.name,
            },
            { value: call.user?.display_name, event: undefined, data: call.user?.application },
            { value: call.assignedTo ? call.assignedTo?.display_name : '–', data: call.assignedTo?.display_name },
          ],
          legend: [
            { value: `${call.event ? (call.event.canceled ? '🔴  Cancelled' : '🟢  Scheduled') : '🟢  Held'}` },
            { value: `${call.event ? 'Booked' : 'Held'} on ${this.datePipe.transform(call.createdAt)}` },
            {
              value: call.noAnswer ? '🔴  No answer' : (call.taken_by ? `🟢 Taken by ${call.taken_by.display_name}` : ''),
            },
            { value: call.email },
          ],
          options: [
            call.callType === 'Inbound' && { value: 'Own', event: 'own', data: call.id },
            call.callType === 'Inbound' && { value: 'Cancel', event: 'cancel', data: call.event.cancel_url ? call.event : call.event_id },
            {
              value: 'Answered', event: 'answered', data: call.id, class: 'lib-button-primary',
            },
            {
              value: 'No answer', event: 'no-answer', data: call, class: 'lib-button-warn',
            },
          ].filter(Boolean),
        };
      }),
    };
  }
}
